// Generic tab/toggle-group controller. A `<vrt-tabs>` host can carry any
// number of independent groups (e.g. "cat" for size-guide categories, "unit"
// for cm/in) — each button declares which group+value it sets via
// `data-tabs-set="group:value"`; matching panels declare
// `data-tabs-panel-group="group" data-tabs-panel="value"`. No group-specific
// logic lives here, so the same element drives size-guide tabs, the cm/in
// toggle, and the shipping-returns return/exchange tabs.

class VrtTabs extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-tabs-set]');
      if (!btn || !this.contains(btn)) return;
      this.activate(btn);
    });

    this.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      const btn = e.target.closest('[data-tabs-set]');
      if (!btn || !this.contains(btn)) return;
      e.preventDefault();
      this.activate(btn);
    });
  }

  activate(btn) {
    const [group, value] = btn.dataset.tabsSet.split(':');

    this.querySelectorAll(`[data-tabs-btn][data-tabs-group="${group}"]`).forEach((b) => {
      const active = b === btn;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-selected', String(active));
    });

    this.querySelectorAll(`[data-tabs-panel-group="${group}"]`).forEach((panel) => {
      panel.hidden = panel.dataset.tabsPanel !== value;
    });
  }
}

if (!customElements.get('vrt-tabs')) {
  customElements.define('vrt-tabs', VrtTabs);
}
